import { id, Identifiable, calendarHolidays, Resource } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getPersonalCalendarHolidays({ uuid }: Identifiable<Resource>) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.calendarHolidays : { ...calendarHolidays };
    },
    isRetrievePersonalCalendarHolidaysRequestFailure({
      uuid,
    }: Identifiable<Resource>) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrievePersonalCalendarHolidaysRequestPending({
      uuid,
    }: Identifiable<Resource>) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrievePersonalCalendarHolidaysRequestSuccess({
      uuid,
    }: Identifiable<Resource>) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
